export default {
footer: {
    ageRestriction: "Ang aming platform ay para lamang sa mga gumagamit na 18 taong gulang pataas. Ang pagsusugal ay maaaring makakahumaling. Mangyaring maglaro nang may pananagutan at para sa libangan lamang. Para sa karagdagang impormasyon, bisitahin ang aming pahina ng Responsableng Pagsusugal.",
    followUs: "I-FOLLOW KAMI",
    company: "KUMPANYA",
    legal: "LEGAL",
    support: "SUPORTA",
    gameProviders: "MGA NAGBIBIGAY NG LARO",
    copyright: "Copyright © 2019-2026 LOGO. Lahat ng Karapatan ay Rezervado.",
	documents: "Mga Dokumento",
  }
}
